



































































































































































import DatePicker from '@/components/date-picker.vue'
import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'

export default Vue.extend({
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: (): {} => ({
        dateStart: moment(),
        dateEnd: moment(),
        query: null as any,
        state: null as any,
        statuses: [],
        includeUsers: [],
        excludeUsers: [],
        developers: [],
        ordering: 'source.name',
        exclusions: false,
        plugable: null as any,
        categories: [],
        industries: [],
      }),
    },
  },
  data: () => ({
    states: [
      {
        value: 1,
        text: 'Без парсеров',
      },
      {
        value: 2,
        text: 'Только с парсерами',
      },
      {
        value: 3,
        text: 'Только с активными парсерами',
      },
      {
        value: 4,
        text: 'Без активных парсеров',
      },
    ],
  }),
  computed: {
    ...mapState('users', {
      users: (state: any) => state.items,
    }),
    ...mapState('statuses', {
      statuses: (state: any) => state.items,
    }),
    ...mapState('categories', {
      categories: (state: any) => state.items,
    }),
    ...mapState('industries', {
      industries: (state: any) => state.items,
    }),
  },
  async mounted() {
    await this.$store.dispatch('users/FETCH')
    await this.$store.dispatch('statuses/FETCH')
    await this.$store.dispatch('industries/FETCH')
    await this.$store.dispatch('categories/FETCH')
    this.onFilterChange()
  },
  methods: {
    onFilterChange() {
      this.$emit('input', this.value)
    },
    onSelectAllUsersClick(field: string) {
      this.value[field] = this.users.map(x => x.id)
      this.onFilterChange()
    },
  },
})
